<button type="button" class="btn btn-toolbar" id="closeButton" (click)="close()">
    &times;
</button>
<div class="wrapper">
    <h1>Impressum</h1>
    <p>
        <a href="https://web.inforge.de/" target="_blank">web.inforge.de</a>
    </p>
    <p>
        Inforge<br>
        Rödgener Str. 83<br>
        35394 Gießen<br>
    </p>
    <p>Entwickelt von:</p>
    <p>
        Fabrik19 GmbH<br>
        Bahnhofstraße 82-86<br>
        35390 Gießen<br>
    </p>
    <h1>Support</h1>
    <p>
        WhatsApp: +491626501359<br>
        Email: <a href="mailto:management@inforge.de">management@inforge.de</a><br>
    </p>
</div>
